export function IconArrowRight() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 8.5L6.5 13.2631L6.5 3.73686L11 8.5Z" fill="currentColor" />
    </svg>
  )
}
